// Estado inicial do Redux para a feature "trade-in-simulations"

const initialState = {
  list: [], // lista retornada pelo GET
  creating: false, // loading do POST
  listLoading: false, // loading do GET
  updatingStatus: false, // loading do PATCH
  error: null, // última mensagem de erro (string) ou objeto
};

export default initialState;
